import us from 'uScope/js/defines';

// TODO: Region Types, Nav Modes, and Draw Modes expose very similar concepts. Consolidate, somehow...

export const NAV_MODES = {
  NONE: 0,
  PIN: 7,
  ARROW: 8,
  RECT: 9,
  ELLIPSE: 10,
  PEN: 11,
  CALIPER: 12,
  TEXT: 13,
  REPORT: 14,
  POLYGON: 15,
  NEGPEN: 16
};

export const REGION_TYPES = {
  PEN: us.eAnTypes.pen,
  RECTANGLE: us.eAnTypes.rect,
  ELLIPSE: us.eAnTypes.ellipse,
  ARROW: us.eAnTypes.arrow,
  RULER: us.eAnTypes.ruler,
  PIN: us.eAnTypes.pin,
  CALIPER: us.eAnTypes.caliper,
  TEXT: us.eAnTypes.text,
  REPORT: us.eAnTypes.report,
  POLYGON: us.eAnTypes.polygon
};

export const DRAW_MODES = [
  {
    name: 'rect',
    action: NAV_MODES.RECT
  },
  {
    name: 'pen',
    action: NAV_MODES.PEN
  },
  {
    name: 'ellipse',
    action: NAV_MODES.ELLIPSE
  },
  {
    name: 'polygon',
    action: NAV_MODES.POLYGON
  },
  {
    name: 'arrow',
    action: NAV_MODES.ARROW
  },
  {
    name: 'pin',
    action: NAV_MODES.PIN
  },
  {
    name: 'caliper',
    action: NAV_MODES.CALIPER
  },
  {
    name: 'text',
    action: NAV_MODES.TEXT
  },
  {
    name: 'report',
    action: NAV_MODES.REPORT
  }
];

export const DRAW_MODE_NAMES = DRAW_MODES.reduce((r, m) => {
  r.push(m.name);
  return r;
}, []);

export const WV_LAYER_NAMES = {
  ANNOTATION: us.AnnotLayerName,
  REPORT: us.ReportLayerName
};

// The MOVE_REGION_CURSOR action allows three options.
export const CURSOR_OPTIONS = ['previous', 'current', 'next'];

export const LAYER_TYPES = {
  ANNOTATION: us.anLayerTypes.manual,
  REPORT: us.anLayerTypes.report
};



// WEBPACK FOOTER //
// ./src/shared/stores/annotations/consts.js